export const iconFontAwesomeMedicalHealthHouseMedicalCircleCheck = (
	<i className="fa-solid fa-house-medical-circle-check"></i>
);
